interface GetTranslationKeysArgs {
  isFamilyVariant: boolean;
  isMobile: boolean;
}

export const getTranslationKeys = ({ isFamilyVariant, isMobile }: GetTranslationKeysArgs) => {
  const dealType = isFamilyVariant ? 'family' : 'generic';
  const keySuffix = isMobile ? '.mobile' : '';

  return {
    titleKey: `sale.${dealType}.assisted.promo.title`,
    subtitleKey: `sale.${dealType}.assisted.promo.subtitle${keySuffix}`,
  };
};
